import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Home, Target, Trophy, Flame, User, Menu, Plus,
  Sparkles, Shield
} from "lucide-react";
import { useApp } from "../../contexts/AppContext";
import { DEMO } from "../../constants/mockData";

export const MobileNav = () => {
  const location = useLocation();
  const { user } = useApp();
  
  const userData = {
    xp: user?.xp || DEMO.user.xp || 2847,
    burnz: user?.burnz_tokens || DEMO.user.burnz_tokens || 850,
    level: user?.level || 4,
    maxXp: 4000,
  };

  const navItems = [
    { path: "/app", icon: Home, label: "Home" },
    { path: "/app/quests", icon: Target, label: "Quests" },
    { path: "/app/dump", icon: Flame, label: "Dump", primary: true },
    { path: "/app/rewards", icon: Trophy, label: "Rewards" },
    { path: "/app/profile", icon: User, label: "Profile" },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0D0D0D]/95 backdrop-blur-xl border-t border-white/10 safe-area-bottom">
      {/* Stats Bar */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-white/5 bg-[#1A1A1A]/50">
        <div className="flex items-center gap-1">
          <Sparkles className="w-3.5 h-3.5 text-cyan-400" />
          <span className="text-cyan-400 font-bold text-sm">{userData.xp.toLocaleString()}</span>
          <span className="text-white/30 text-xs">XP</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-orange-400 font-bold text-sm">B</span>
          <span className="text-orange-400 font-bold text-sm">{userData.burnz}</span>
        </div>
        <div className="flex items-center gap-1">
          <div className="w-16 h-1.5 bg-white/10 rounded-full overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-purple-500 to-cyan-500 rounded-full transition-all"
              style={{ width: `${(userData.xp / userData.maxXp) * 100}%` }}
            />
          </div>
          <span className="text-white/50 text-xs">Lv.{userData.level}</span>
        </div>
      </div>
      
      {/* Navigation Items */}
      <div className="flex items-center justify-around px-2 py-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path === "/app" && location.pathname === "/app");
          const Icon = item.icon;
          
          if (item.primary) {
            return (
              <Link
                key={item.path}
                to={item.path}
                className="flex flex-col items-center justify-center -mt-6"
              >
                <div className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg shadow-orange-500/30 ${
                  isActive 
                    ? 'bg-gradient-to-br from-orange-500 to-red-600' 
                    : 'bg-gradient-to-br from-orange-500/80 to-red-600/80'
                }`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <span className={`text-[10px] mt-1 font-medium ${isActive ? 'text-orange-400' : 'text-white/50'}`}>
                  {item.label}
                </span>
              </Link>
            );
          }

          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center py-2 px-3"
            >
              <Icon className={`w-5 h-5 ${isActive ? 'text-purple-400' : 'text-white/40'}`} />
              <span className={`text-[10px] mt-1 ${isActive ? 'text-purple-400 font-medium' : 'text-white/40'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
